import { styled } from '@topwrite/common';
import { memo, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { BsCaretDownFill, BsCaretUpFill, BsCheckCircleFill } from 'react-icons/bs';
import Content from './content';

interface Props {
    reasoning?: string;
    loading?: boolean;
}

const Reasoning = memo(({ reasoning, loading }: Props) => {
    const [show, setShow] = useState(false);

    return <div className='mb-2'>
        <ReasoningContainer className='rounded fs-7'>
            <div onClick={() => setShow(loading || !show)} role='button' className='d-flex align-items-center p-1 px-2 gap-2'>
                {loading ? <Spinner animation='border' variant='primary' size='sm' /> :
                    <BsCheckCircleFill className='text-success' />}
                <span className='text-muted'>{loading ? '思考中' : '已思考'}</span>
                {(show || loading) && reasoning && (show ?
                    <BsCaretUpFill className='text-muted ms-auto' /> :
                    <BsCaretDownFill className='text-muted ms-auto' />)}
            </div>
            {show && reasoning && <div className='border-top p-2 d-flex flex-column gap-2'>
                <ReasoningSection className='border rounded'>
                    <ReasoningContent className='p-2'>
                        <Content value={reasoning} />
                    </ReasoningContent>
                </ReasoningSection>
            </div>}
        </ReasoningContainer>
    </div>;
});

const ReasoningContainer = styled.div`
    background: var(--ttw-editor-background);
    box-shadow: var(--ttw-shadow);
`;

const ReasoningSection = styled.div`
    background: var(--ttw-priview-background);
`;

const ReasoningContent = styled.div`
    white-space: pre-wrap;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 300px;
`;

export default Reasoning;
